import { FC } from "react";

import styles from "./styles.module.scss";

const Loader: FC = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
            }}
        >
            <div className={styles.spinner} />
        </div>
    );
};

export default Loader;
